export const X_LIMIT = 2;

export const FEATURE_TOGGLES = {
  showSimpleEntry: process.env.VUE_APP_SHOW_SIMPLE_ENTRY == "true",
  showMassEntryV1: process.env.VUE_APP_SHOW_MASS_ENTRY_V1 == "true",
  showMassEntryV2: process.env.VUE_APP_SHOW_MASS_ENTRY_V2 == "true",
  showSavedBet: process.env.VUE_APP_SHOW_SAVED_BET == "true",
  useV1Legacy: process.env.VUE_APP_USE_V1_LEGACY == "true",
  useMenuColours: process.env.VUE_APP_USE_MENU_COLOURS == "true",
  clickableDdReportPosition: process.env.VUE_APP_CLICKABLE_DD_REPORT_POSITION == "true",
  clickableTtReportPosition: process.env.VUE_APP_CLICKABLE_TT_REPORT_POSITION == "true",
  honoRpcEnabled: process.env.VUE_APP_HONO_RPC_ENABLED == "true",
  honoRpcSettingsEnabled:
    process.env.VUE_APP_HONO_RPC_SETTINGS_ENABLED == "true",
};

// console.debug({ FEATURE_TOGGLES });
